export default __webpack_public_path__ + "images/upper-arch.9861b07571434b4dec17d2f6e0d0603b.svg";